import NetlifyWebhookTemplate from './NetlifyWebhookTemplate.es6';
import GoogleCloudWebhookTemplate from './GoogleCloudWebhookTemplate.es6';
import SlackWebhookTemplate from './SlackWebhookTemplate.es6';
import TwilioWebhookTemplate from './TwilioWebhookTemplate.es6';
import MailgunWebhookTemplate from './MailgunWebhookTemplate.es6';
import JiraWebhookTemplate from './JiraWebhookTemplate.es6';
import PubNubWebhookTemplate from './PubNubWebhookTemplate.es6';
import CircleCIWebhookTemplate from './CircleCIWebhookTemplate.es6';
import HerokuWebhookTemplate from './HerokuWebhookTemplate.es6';
import TravisCIWebhookTemplate from './TravisCIWebhookTemplate.es6';
import WebtaskWebhookTemplate from './WebtaskWebhookTemplate.es6';
import GitlabWebhookTemplate from './GitlabWebhookTemplate.es6';
import AlgoliaWebhookTemplate from './AlgoliaWebhookTemplate.es6';
import ElasticWebhookTemplate from './ElasticWebhookTemplate.es6';
import AwsLambdaWebhookTemplate from './AwsLambdaWebhookTemplate.es6';
import AwsS3WebhookTemplate from './AwsS3WebhookTemplate.es6';
import AwsSqsWebhookTemplate from './AwsSqsWebhookTemplate.es6';
import BitbucketWebhookTemplate from './BitbucketWebhookTemplate.es6';

export default [
  NetlifyWebhookTemplate,
  HerokuWebhookTemplate,
  TravisCIWebhookTemplate,
  CircleCIWebhookTemplate,
  GitlabWebhookTemplate,
  BitbucketWebhookTemplate,
  AwsLambdaWebhookTemplate,
  GoogleCloudWebhookTemplate,
  WebtaskWebhookTemplate,
  SlackWebhookTemplate,
  TwilioWebhookTemplate,
  MailgunWebhookTemplate,
  AwsSqsWebhookTemplate,
  PubNubWebhookTemplate,
  AwsS3WebhookTemplate,
  AlgoliaWebhookTemplate,
  ElasticWebhookTemplate,
  JiraWebhookTemplate
];



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/index.es6.js